import { createSlice } from '@reduxjs/toolkit'
import {
  fetchReservations,
  fetchUpcomingCount,
} from './myEventModalThunks';
import { joinRoom } from "../interact/interactThunks";
import socketFactory from '../../../../utils/socketFactory.js';

const initialState = {
  reservations: [],
  reservationsLoading: false,
  reservationTab: 0,
  initialReservation: [],
  joiningRoom: false,
  upcomingCount: 0,
  upcomingCountLoading: false,
}

const getFilteredReservationsList = (data) => {
  const now = new Date();
  const toEndTs = (reservation) => {
    const start = new Date(reservation.date).getTime();
    const durationMin = Number(reservation.duration || 0);
    return start + durationMin * 60_000;
  };

  const sorted = {
    upcoming: [],
    past: [],
  };
  data.forEach((reservation) => {
    const endTs = toEndTs(reservation);
    const isEnded = endTs <= now.getTime();
    const isParent =
      reservation.recurrence_unit && reservation.recurrence_unit !== "none";
    const hasChildren = reservation.children && reservation.children.length > 0;
    const upcomingChildren = (reservation.children || []).filter(
      (child) =>
        new Date(child.date).getTime() + Number(child.duration || 0) * 60_000 >
        now.getTime()
    );
    const pastChildren = (reservation.children || []).filter(
      (child) =>
        new Date(child.date).getTime() + Number(child.duration || 0) * 60_000 <=
        now.getTime()
    );
    const processed = {
      ...reservation,
      childrenUpcoming: upcomingChildren,
      childrenPast: pastChildren,
    };

    const isActiveConference = reservation.type === "conference" && reservation.is_active === true;


    if (isParent) {
      sorted.upcoming.push(processed);
      if (isEnded || pastChildren.length > 0) {
        sorted.past.push(processed);
      }
    }
    else if (isActiveConference) {
      sorted.upcoming.push(processed);

    }
    else if (reservation.parent_booking_id) {
      if (isEnded) sorted.past.push(processed);
      else sorted.upcoming.push(processed);
    }
    else if (!isParent && !reservation.parent_booking_id) {
      if (isEnded) sorted.past.push(processed);
      else sorted.upcoming.push(processed);
    }
  });

  sorted.upcoming.sort((a, b) => new Date(a.date) - new Date(b.date));
  sorted.past.sort(
    (a, b) =>
      new Date(b.date).getTime() + Number(b.duration || 0) * 60_000 -
      (new Date(a.date).getTime() + Number(a.duration || 0) * 60_000)
  );

  return sorted;
};
const myEventModalSlice = createSlice({
  name: 'myEventModal',
  initialState,
  reducers: {
    setReservationsLoading: (state, action) => {
      state.reservationsLoading = action.payload
    },
    setReservationTab: (state, action) => {
      state.reservationTab = action.payload
    },
    setInitialReservation: (state, action) => {
      state.initialReservation = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReservations.fulfilled, (state, action) => {
        state.reservations = getFilteredReservationsList(action.payload);
        state.reservationsLoading = false;

      })
      .addCase(fetchUpcomingCount.pending, (state) => {
        state.upcomingCountLoading = true;
      })
      .addCase(fetchUpcomingCount.fulfilled, (state, action) => {
        state.upcomingCount = action.payload?.count ?? 0;
        state.upcomingCountLoading = false;
      })
      .addCase(fetchUpcomingCount.rejected, (state) => {
        state.upcomingCount = 0;
        state.upcomingCountLoading = false;
      })
      .addCase(joinRoom.pending, (state) => { state.joiningRoom = true; })
      .addCase(joinRoom.fulfilled, (state) => { state.joiningRoom = false; })
      .addCase(joinRoom.rejected, (state) => { state.joiningRoom = false; });
  },
}
)

export const {
  setReservationsLoading,
  setReservationTab,
  setInitialReservation,
  guestJoinTooEarly,
} = myEventModalSlice.actions

console.log("type of fetchUpcomingCount: ", fetchUpcomingCount?.typePrefix)
socketFactory.on("bookingUpdated", fetchUpcomingCount);
export default myEventModalSlice.reducer;